import { render, staticRenderFns } from "./simpleFilterItem.vue?vue&type=template&id=1adfb122&scoped=true"
import script from "./simpleFilterItem.vue?vue&type=script&lang=js"
export * from "./simpleFilterItem.vue?vue&type=script&lang=js"
import style0 from "./simpleFilterItem.vue?vue&type=style&index=0&id=1adfb122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adfb122",
  null
  
)

export default component.exports